import { Toast } from 'antd-mobile';
export const loadingToast = (text)=>{
    Toast.loading(text, 30, () => {
        console.log('Load complete !!!');
    });
}


// WEBPACK FOOTER //
// ./src/authCertificateCompact/modules/loading/index.js